import {connect} from 'react-redux'
import {Title} from 'report-components'
import {updateReportTitle,autoSaveUpdate} from 'report-components/lib/reducers'

const autoSaveType = {type:"reportTitle"}

export const ReportTitle = connect(
  ({report}) => ({
    reportTitle: report.reportTitle,
    language: report.reportSettings.layout.language,
    dateFormat: report.reportSettings.layout.dateFormat
  }),
  (dispatch) => ({
    update: (props) => dispatch(updateReportTitle(props)),
    saveUpdate: (item) => dispatch(autoSaveUpdate(item, autoSaveType))
  })
)(Title)


// WEBPACK FOOTER //
// ./src/javascripts/report/ReportTitle.jsx